import React from "react";
import SignupMain from "./SignupMain";

export default function SignupPage() {
  return (
    <div>
      <SignupMain />
    </div>
  );
}
